export default "__VITE_ASSET__DHbPC7TJ__"